/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';

import type { TrackEvent, UseQuery, UseMutation } from './types';
import { useAlertBanner } from './useAlertBanner/useAlertBanner';
import { Currency, useCurrencies } from '@zapier/currency';

type Props = {
  /**
   * `useQuery` function for fetching data, typically supplied by Apollo.
   */
  useQuery: UseQuery;
  /**
   * `useMutation` function for executing mutations, typically supplied by Apollo.
   */
  useMutation: UseMutation;
  /**
   * Function to track user events when they occur.
   */
  trackEvent: TrackEvent;
};

/**
 * The banner that renders above `UniversalNav` for important alerts.
 */
export const AlertBanner = (props: Props) => {
  const { Component, data } = useAlertBanner({ useQuery: props.useQuery });

  const { currencies, isLoading: isLoadingCurrencies } = useCurrencies({
    // See https://github.com/zapier/design-system/pull/219#discussion_r625905431
    //@ts-ignore
    useQuery: props.useQuery,
  });

  if (!Component || isLoadingCurrencies) {
    return null;
  }

  return (
    <Component
      data={data}
      currency={currencies?.find(
        (c: Currency) => c.name === data?.currentAccount.currency
      )}
      layout="banner"
      trackEvent={props.trackEvent}
      useQuery={props.useQuery}
      useMutation={props.useMutation}
    />
  );
};
